import {useCallback, useEffect, useState} from 'react'

import {useDispatch, useSelector} from 'react-redux'

import {setRefresh} from '@/redux/actions'
import {Entities, RefreshType, RequestStatus} from '@/typedef'
import {getIncident} from '@/modules/ITSM/api/incidentsRequests'
import {useFetchHook} from '@/hooks/useFetch'
import {getKRequest} from '@/modules/ITSM/api/kRequestsRequests'
import {selectRefresh} from '@/redux/reducers/generalSelector'

import {TIncident} from '../typedf'

export function useGetIncidentRequest(
  entity: string,
  id: string
): {
  readonly getData: (timer?: boolean) => Promise<TIncident | undefined>
  readonly entityData: TIncident | undefined
  readonly fetchStatus: RequestStatus
} {
  const refresh = useSelector(selectRefresh)

  const [entityData, setEntityData] = useState<TIncident>()

  const {
    status,
    handleRequested,
    handleSuccess,
    handleFail,
    handleReset,
  } = useFetchHook()

  const dispatch = useDispatch()

  const getData = useCallback(
    async (timer?: boolean) => {
      try {
        if (!timer) handleRequested()
        const {
          body: {result},
        } =
          entity === Entities.INCIDENT
            ? await getIncident(id)
            : await getKRequest(id)
        if (result) {
          if (!timer) {
            setEntityData(result)
            handleSuccess()
          }
          return result
        }
        return undefined
      } catch (err) {
        if (!timer) handleFail(err)
      } finally {
        if (!timer) handleReset()
      }
    },
    [entity, handleFail, handleRequested, handleReset, handleSuccess, id]
  )

  const {isRefreshing, type} = refresh

  useEffect(() => {
    if (
      isRefreshing &&
      type ===
        (entity === Entities.INCIDENT
          ? RefreshType.IncidentNotif
          : RefreshType.KrequestNotif)
    ) {
      setEntityData(undefined)
      getData()
      dispatch(setRefresh(false))
    }
  }, [id, getData, isRefreshing, type, setEntityData, dispatch, entity])

  return {
    getData,
    entityData,
    fetchStatus: status,
  }
}
